import { DateTime } from "luxon";

export class ShiftDTO {
  id?: number;
  date?: DateTime;
  dayOrNight?: string;
  crew?: string;

  constructor(data: ShiftDTO) {
    Object.assign(this, data);
  }

  static is(obj: any): obj is ShiftDTO {
    return obj && typeof obj === "object" && ("date" in obj || "dayOrNight" in obj);
  }
}